<div class="header-bg" [ngClass]="{'content-bg': isTransparentHeader}">
  <div class="header" [ngClass]="{'header--center': onlyLogoHeader}">
    <div class="logo-container" [ngClass]="{'logo-container--center': onlyLogoHeader}">
      <div class="logo pointer" [routerLink]="[dashboardRoute]"></div>
    </div>
    @if(!onlyLogoHeader) {
      @if(previewOnlyHeaderText) {
        <div class="preview-container">
          {{ 'global.previewVersion' | translate }}
        </div>
      } @else {
        @if (showHeaderLinks) {
          <div class="header-links">
            <liberro-basic-layout-header-links></liberro-basic-layout-header-links>
          </div>
        }

        <div class="action-buttons-container">

          @if (!showHeaderHamburger) {
            @if (authenticatedHeader) {
              <a nz-button nzType="link" [nzDanger]="'bwm' | appMode" [routerLink]="needHelpLink" class="action-btn underline need-help" data-cy="header-need-help-link">
                <span>{{ 'global.button.needHelp' | translate }}</span>
              </a>
              <!-- Desktop home/end session button -->
              <button nz-button nzType="default" [nzShape]="actionBtnShape()" [nzDanger]="'bwm' | appMode" [routerLink]="[dashboardRoute]" class="action-btn action-btn--desktop" data-cy="header-home-button">
                {{ actionBtnKey() | translate }}
              </button>
            } @else if ('bwm' | appMode) {
              <a nz-button nzType="link" [nzDanger]="'bwm' | appMode" class="action-btn underline" [href]="workplaceLoginUrl">
                <span>{{ 'global.button.bwmWorkplace' | translate }}</span>
              </a>
            }
          }

          <!-- Mobile close icon -->
          @if (!showHeaderHamburger && !isLoginUrl) {
            <button nz-button nzType="text" [nzDanger]="'bwm' | appMode" class="action-btn close action-btn--mobile" [routerLink]="[dashboardRoute]" data-cy="header-close-button">
              <svg-icon
                [src]="'assets/icons/cross.svg'"
              ></svg-icon>
            </button>
          }

          <!-- Liberro hamburger -->
          @if ('liberro' | appMode) {
            <svg-icon
              class="liberro-hamburger pointer"
              [src]="'assets/icons/liberro-hamburger.svg'"
            ></svg-icon>
          }

          <!-- BWM hamburger -->
          @if (showHeaderHamburger && ('bwm' | appMode)) {
            <liberro-basic-layout-hamburger-control
              [desktopOpen]="desktopHamburgerMenuOpened()"
              [mobileOpen]="mobileHamburgerMenuOpened()"
              (desktopVisibleChange)="onHamburgerPanelVisibilityChange($event)"
              (toggleMobile)="toggleHamburgerMenu()"
              (mobileItemClick)="closeMobileHamburgerMenu()"
              (logout)="logout()"
            ></liberro-basic-layout-hamburger-control>
          }

        </div>
      }
    }
  </div>
</div>
